import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import lineInteractHOC from '../../hoc/lineInteractHoc';

/**
 * The default fill color for the line handle.
 * @const {string}
 */
const DEFAULT_HANDLE_COLOR = '#0096fd';

/**
 * The DisplayLineHandle component.
 */
export class DisplayLineHandle extends React.Component {
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {handleColor, radius, x, y} = this.props;

    const style = {opacity: 0};
    if (this.props.show) {
      style.opacity = 0.5;
    }

    return (
      <circle
        className="display-line-handle"
        cx={x}
        cy={y}
        r={radius}
        fill={handleColor || DEFAULT_HANDLE_COLOR}
        {...style}
        pointerEvents="visible"
      />
    );
  }
}

DisplayLineHandle.propTypes = {
  entity: MobxPropTypes.observableMap.isRequired,
  game: PropTypes.object.isRequired,
  isDrag: PropTypes.bool.isRequired,
  isStart: PropTypes.bool.isRequired,
  radius: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,

  handleColor: PropTypes.string,
};

export default lineInteractHOC(
  observer(DisplayLineHandle)
);
